import { CONNECTORS_PATH, CONNECTOR_TABS } from "./connectorNavigation";
/** Retour limité aux onglets connus des connecteurs ; aucune URL extérieure ni route libre. */
export function connectorMailReturn(
  state: unknown,
  role: string | null,
): string | null {
  if (
    role !== "super_admin" ||
    !state ||
    typeof state !== "object" ||
    !("from" in state) ||
    typeof state.from !== "string"
  )
    return null;
  let url: URL;
  try {
    url = new URL(state.from, "https://ems.invalid");
  } catch {
    return null;
  }
  if (
    url.origin !== "https://ems.invalid" ||
    !(
      (url.pathname === CONNECTORS_PATH && url.searchParams.get("connector")) ||
      /^\/app\/admin\/connectors\/[^/]+$/.test(url.pathname)
    ) ||
    (url.searchParams.has("tab") &&
      !CONNECTOR_TABS.some((tab) => tab === url.searchParams.get("tab")))
  )
    return null;
  return `${url.pathname}${url.search}`;
}
